import { render, staticRenderFns } from "./CustomerTicketView.vue?vue&type=template&id=8228eaaa&scoped=true&"
import script from "./CustomerTicketView.vue?vue&type=script&lang=js&"
export * from "./CustomerTicketView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTicketView.vue?vue&type=style&index=0&id=8228eaaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8228eaaa",
  null
  
)

export default component.exports